import { useState } from 'react'
import styles from './Header.module.scss'
import { Menu } from './Menu'
import { Logo } from './Logo'
import { useQuery } from '@/utils/url'
import { Button } from './Button'
// import { MenuOffcanvas } from '@/components/modals/MenuOffcanvas'

export function Header({
  hideMenu = false,
  className = '',
  children
}) {
  const [showMenu, setShowMenu] = useState(false)

  return (
    <header className={`${styles.header} ${className} flex justify-between sm:px-0`}>
      <Logo className="scale-[0.75] md:scale-[1] origin-center md:origin-left"/>
      <div className='flex'>
        <div className='hidden md:flex'>
          {children}
        </div>
        <Button href={useQuery(process.env.NEXT_PUBLIC_COURSE_APP + '/signin')} radius={0} size="large" className="ml-[30px] px-[40px] py-[10px]" uppercase={false}><span className="text-[18px]">Login</span></Button>
      </div>
    </header>
  )
}
